import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getRegionForServiceShop = createAsyncThunk('/getRegionForServiceShop', async () => {
  const response = await axios.get('/GetRegionForServiceShop');
  return response.data;
});

export const getSubServiceShops = createAsyncThunk('/GetSubServiceShops', async (ParentSourceServiceShopId) => {
  const response = await axios.get(`/GetSubServiceShops/${ParentSourceServiceShopId}`);
  return response.data;
});

export const getProductRelease = createAsyncThunk('/GetProductRelease', async () => {
  const response = await axios.get(`/GetProductRelease`);
  return response.data;
});

export const getProductReleaseById = createAsyncThunk('/GetProductReleaseById', async (Id) => {
  const response = await axios.get(`/GetProductReleaseById/${Id}`);
  return response.data;
});

export const deleteProductRelease = createAsyncThunk('/DeleteProductRelease', async (Id) => {
  const response = await axios.post(`/DeleteProductRelease/${Id}`);
  return response.data;
});

export const getProductReleaseByAppId = createAsyncThunk('/GetProductReleaseByAppId', async (Id) => {
  const response = await axios.get(`/GetProductReleaseByAppId/${Id}`);
  return response.data;
});

export const getServiceShopDetails = createAsyncThunk('/GetServiceShopDetails', async (ServiceShopId) => {
  const response = await axios.get(`/GetServiceShopDetails/${ServiceShopId}`);
  return response.data;
});

export const getServiceShopCoefficient = createAsyncThunk(
  'serviceShop/getServiceShopCoefficient',
  async ({ serviceShopId }) => {
    if (!serviceShopId) return [];
    const response = await axios.get(`/getServiceShopCoefficient/${serviceShopId}`);
    return response.data;
  }
);

export const getDistrictManagers = createAsyncThunk(
  'serviceShop/getDistrictManagers',
  async ({ serviceShopId }) => {
    if (!serviceShopId) return [];
    const response = await axios.get(`/GetDistrictManagers/${serviceShopId}`);
    return response.data;
  }
);

export const getServiceShopTypeDetails = createAsyncThunk('/GetServiceShopTypeDetails', async (ServiceShopTypeId) => {
  const response = await axios.get(`/GetServiceShopTypeDetails/${ServiceShopTypeId}`);
  return response.data;
});

export const setServiceShopDetails = createAsyncThunk('/SetServiceShopDetails', async (req) => {
  const response = await axios.post(`/SetServiceShopDetails`, req);
  return response.data;
});

export const addProductRelease = createAsyncThunk('/addProductRelease', async (req) => {
  const response = await axios.post(`/AddProductRelease`, req);
  return response.data;
});

export const getServiceShopTypes = createAsyncThunk('/GetServiceShopType', async () => {
  const response = await axios.get('/GetServiceShopType');
  return response.data;
});

export const getServiceShopPostCodeMap = createAsyncThunk('/GetServiceShopPostCodeMap', async (search) => {
  const response = await axios.get(`/GetServiceShopPostCodeMap/${search}`);
  return response.data;
});

export const getSchemes = createAsyncThunk('/getSchemes', async (search) => {
  const response = await axios.get(`/getSchemes/${search}`);
  return response.data;
});

export const getMonthlyTransportation = createAsyncThunk('/GetMonthlyTransportation', async (search) => {
  const response = await axios.get(`/GetMonthlyTransportation/${search}`);
  return response.data;
});

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const setPushPostCodeMap = createAsyncThunk('/SetPushPostCodeMap', async (push) => {
  const response = await axios.post(`/SetPushPostCodeMap`, push);
  return response.data;
});

export const setPushPostCodeMapRussia = createAsyncThunk('/setPushPostCodeMapRussia', async (push) => {
  const response = await axios.post(`/setPushPostCodeMapRussia`, push);
  return response.data;
});

export const SetSchemes = createAsyncThunk('/SetSchemes', async (push) => {
  const response = await axios.post(`/SetSchemes`, push);
  return response.data;
});

export const setPushMonthlyTransportation = createAsyncThunk('/SetPushMonthlyTransportation', async (push) => {
  const response = await axios.post(`/SetPushMonthlyTransportation`, push);
  return response.data;
});


export const getServiceShopPaymentGroup = createAsyncThunk('/getServiceShopPaymentGroup', async () => {
  const response = await axios.get('/GetServiceShopPaymentGroup');
  return response.data;
});

export const getServiceShopTaskType = createAsyncThunk('/getServiceShopTaskType', async () => {
  const response = await axios.get('/GetActiveTaskType');
  return response.data;
});

export const getApplicationType = createAsyncThunk('/getApplicationType', async () => {
  const response = await axios.get('/GetApplicationType');
  return response.data;
});


export const getServiceTypes = createAsyncThunk('/getServiceTypes', async () => {
  const response = await axios.get('/GetServiceTypes');
  return response.data;
});

export const getDeletePostCodeMap = createAsyncThunk(`/GetDeletePostCodeMap`, async (id) => {
  const response = await axios.get(`/GetDeletePostCodeMap/${id}`);
  return response.data;
});

export const deleteSchemes = createAsyncThunk(`/deleteSchemes`, async (ids) => {
  const response = await axios.get(`/deleteSchemes/${ids}`);
  return response.data;
});

export const getDeleteMonthlyTransportation = createAsyncThunk(`/GetDeleteMonthlyTransportation`, async (id) => {
  const response = await axios.get(`/GetDeleteMonthlyTransportation/${id}`);
  return response.data;
});

export const getDistributor = createAsyncThunk('GetDistributor', async() => {
  const response = await axios.get('/GetDistributor')
  return response.data
})

const serviceShopSlice = createSlice({
  name: 'serviceShop',
  initialState: {
    loading: false,
    error: '',
    ServiceShopTypes: [],
    RegionServiceControl: [],
    SubServiceShopControl: [],
    ProductReleaseControl: [],
    ProductReleaseByAppIdControl: [],
    ServiceShopDataControl: [],
    ServiceShopPostCodeMap: [],
    Schemes: [],
    SelectedAppTranslationId: 0,
    ServiceShopDescriptions: [],
    ServiceShopTypeDescriptions: [],
    ServiceShopPaymentGroup:[],
    ServiceShopTaskType:[],
    ApplicationType:[],
    IsChecked: true,
    ServiceTypes:[],
    DeletePostCode: [],
    DistributorList: [],
    CoefficientValue: []
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.ServiceShopTypeDescriptions = [];
      state.ServiceShopPostCodeMap = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },
  extraReducers: {
    [getServiceShopTypes.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopTypes.fulfilled]: (state, action) => {
      state.ServiceShopTypes = action.payload;
      state.loading = false;
    },
    [getRegionForServiceShop.pending]: (state) => {
      state.loading = true;
    },
    [getRegionForServiceShop.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRegionForServiceShop.fulfilled]: (state, action) => {
      state.RegionServiceControl = action.payload;
      state.loading = false;
    },
    [getSubServiceShops.pending]: (state) => {
      state.loading = true;
    },
    [getSubServiceShops.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSubServiceShops.fulfilled]: (state, action) => {
      state.SubServiceShopControl = action.payload;
      state.loading = false;
    },
    [getProductRelease.pending]: (state) => {
      state.loading = true;
    },
    [getProductRelease.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getProductRelease.fulfilled]: (state, action) => {
      state.ProductReleaseControl = action.payload;
      state.loading = false;
    },
    [getProductReleaseByAppId.pending]: (state) => {
      state.loading = true;
    },
    [getProductReleaseByAppId.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getProductReleaseByAppId.fulfilled]: (state, action) => {
      state.ProductReleaseByAppIdControl = action.payload;
      state.loading = false;
    },
    [getServiceShopDetails.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopDetails.fulfilled]: (state, action) => {
      state.ServiceShopDataControl = action.payload;
      state.loading = false;
    },
    [getServiceShopCoefficient.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopCoefficient.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopCoefficient.fulfilled]: (state, action) => {   
      state.CoefficientValue = action.payload;
      state.loading = false;
    },
    [getDistrictManagers.fulfilled]: (state, action) => {
      state.DistrictManagers = action.payload;
      state.loading = false;
    },
    [setServiceShopDetails.pending]: (state) => {
      state.loading = true;
    },
    [setServiceShopDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setServiceShopDetails.fulfilled]: (state, action) => {
      state.ServiceShopDataControl = action.payload;
      state.loading = false;
    },
    [getServiceShopPostCodeMap.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopPostCodeMap.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopPostCodeMap.fulfilled]: (state, action) => {
      state.ServiceShopPostCodeMap = action.payload;
      state.loading = false;
    },
    [getSchemes.pending]: (state) => {
      state.loading = true;
    },
    [getSchemes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSchemes.fulfilled]: (state, action) => {
      state.Schemes = action.payload;
      state.loading = false;
    },
    [getServiceShopTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopTypeDetails.fulfilled]: (state, action) => {
      state.ServiceShopTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.ServiceShopTypeDescriptions = action.payload;
      state.loading = false;
    },
    [setPushPostCodeMap.pending]: (state) => {
      state.loading = true;
    },
    [setPushPostCodeMap.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setPushPostCodeMap.fulfilled]: (state, action) => {
      state.ServiceShopPostCodeMap = action.payload;
      state.loading = false;
    },
    [setPushPostCodeMapRussia.pending]: (state) => {
      state.loading = true;
    },
    [setPushPostCodeMapRussia.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setPushPostCodeMapRussia.fulfilled]: (state, action) => {
      state.ServiceShopPostCodeMap = action.payload;
      state.loading = false;
    },
    [SetSchemes.pending]: (state) => {
      state.loading = true;
    },
    [SetSchemes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [SetSchemes.fulfilled]: (state, action) => {
      state.Schemes = action.payload;
      state.loading = false;
    },
    [getServiceShopPaymentGroup.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopPaymentGroup.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopPaymentGroup.fulfilled]: (state, action) => {
      state.ServiceShopPaymentGroup = action.payload;
      state.loading = false;
    },
    [getServiceShopTaskType.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopTaskType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopTaskType.fulfilled]: (state, action) => {
      state.ServiceShopTaskType = action.payload;
      state.loading = false;
    },
    [getApplicationType.pending]: (state) => {
      state.loading = true;
    },
    [getApplicationType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getApplicationType.fulfilled]: (state, action) => {
      state.ApplicationType = action.payload;
      state.loading = false;
    },
    [getServiceTypes.pending]: (state) => {
      state.loading = true;
    },
    [getServiceTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceTypes.fulfilled]: (state, action) => {
      state.ServiceTypes = action.payload;
      state.loading = false;
    },
    [getDistributor.pending]: (state) => {
      state.loading = true;
    },
    [getDistributor.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDistributor.fulfilled]: (state, action) => {
      state.DistributorList = action.payload;
      state.loading = false;
    }
  }
});
export const serviceShopActions = serviceShopSlice.actions;
export default serviceShopSlice;
